'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _module = angular.module('cb.strips.cbContentAccordionSmall', []);

_module.directive('cbContentAccordionSmallV1', cbContentAccordionSmallV1);

exports.default = _module;


function cbContentAccordionSmallV1() {
    return {
        restrict: 'A',
        scope: {},
        link: cbContentAccordionSmallV1Link
    };

    function cbContentAccordionSmallV1Link(scope, element, attr) {
        var version = 1.00;
        var container = element[0];
        var expandedClass = 'content-accordion-small--expanded';
        var headerSelector = '.content-accordion-small__header';
        var arrowSelector = '.content-accordion-small__arrow';

        container.querySelector(headerSelector).addEventListener('click', toggleExpandable);

        // If the element alreadt has the expanded class make sure the spot and arrow are in the correct state
        if (container.classList.contains(expandedClass)) {
            var arrow = container.querySelector(arrowSelector);
            arrow.classList.remove('icon--arrow-down');
            arrow.classList.add('icon--arrow-up');
        }

        function toggleExpandable(event) {
            this.parentNode.classList.toggle(expandedClass);

            var arrow = this.querySelector(arrowSelector);
            arrow.classList.toggle('icon--arrow-up');
            arrow.classList.toggle('icon--arrow-down');
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/cb-content-accordion-small.directive.js
// module id = 856
// module chunks = 0